import { LeafButtonLink } from "./button-link.component.js";
customElements.define("leaf-button-link", LeafButtonLink);
export {
  LeafButtonLink
};
//# sourceMappingURL=button-link.js.map
